import { useParams } from '@fs/zion-router'
import Cache from '@fs/zion-cache'
import { mutate } from 'swr'
import type { PersonId } from '@fs/zion-tree-types'
import { useEffect, useState } from 'react'
import { useGroupsContext } from '@fs/zion-tree-groups'
import type { SwrResponse } from './useSwrRequest'
import { useSwrRequest } from './useSwrRequest'
import type { ChangeLogSummary } from './changelogs'
import { EXCLUDED_CHANGE_TYPES } from '../changelog/constants'

const cache = new Cache({ storeName: 'changesSummary_r9', encrypted: process.env.NODE_ENV === 'production' })
export const swrKey = (pid: string, treeId: string, count?: number): string => {
  const countQuery = count && count !== 3 ? `&count=${count}` : ''
  return pid ? `/service/tree/tree-data/v8/changes/person/${pid}/summary?treeId=${treeId}${countQuery}` : ''
}

export default function useChangeLogSummary(
  shouldOverridePid?: boolean
): SwrResponse<ChangeLogSummary> & { changeLogSummary?: ChangeLogSummary } {
  const [count, setCount] = useState(3)
  const { pid } = useParams()
  const { currentTreeId } = useGroupsContext()
  const response = useSwrRequest<ChangeLogSummary>(
    swrKey(shouldOverridePid ? undefined : pid, currentTreeId || 'PRIVATE', count),
    cache,
    {
      refreshInterval: 10 * 60 * 1000 /* Refresh data every 10 minutes */,
      requestOptions: {
        validateStatus: (status) => (status >= 200 && status < 300) || status === 304 || status === 410,
      },
    }
  )

  if (response.data?.changes) {
    response.data.changes = response.data?.changes?.filter(
      (change) => !EXCLUDED_CHANGE_TYPES.includes(change.changeType)
    )
  }

  useEffect(() => {
    if (response.data?.changes && response.data.changes.length < 3) {
      response.data?.changes && setCount((prev) => prev + 3 - response.data!.changes.length)
    }
  }, [response.data])
  return { ...response, changeLogSummary: response.data }
}

export function mutateChangeLogSummary(pid: PersonId, treeId: string): void {
  mutate(swrKey(pid, treeId))
}
